import React from 'react'
import SpaceSummary from './SpaceInfo/SpaceSummary'
import Hold from '../SidebarBlocks/Hold'
import Note from '../SidebarBlocks/Note'
import Availability from '../SidebarBlocks/Availability'
import Commitment from '../SidebarBlocks/Commitment'
import PPWKSection from '../SidebarBlocks/PPWKSection'
import BPO from '../SidebarBlocks/BPO'
import { Text } from '@wework/dieter-ui'
import _ from 'lodash'
import ProductData from '../SidebarBlocks/ProductInformation'
import AvailabilityData from '../SidebarBlocks/AvailabilityInformation'

interface Props {
  space: any
  renderSpacePreviewContents(space): React.ReactNode
}

const SpacePreview = ({ space, renderSpacePreviewContents }: Props) => {
  if (!space) {
    return null
  }

  let hasBorder = true
  if (!space.reservable) {
    hasBorder = false
  }

  if (renderSpacePreviewContents) {
    return (
      <div style={{ pointerEvents: 'none' }}>
        {renderSpacePreviewContents(space)}
      </div>
    )
  }
  let isBPO = false

  if (
    space.inventoryData &&
    space.inventoryData?.relationships?.length > 0 &&
    space.inventoryData?.relationships[0]?.product_type ===
      'BOOKABLE_PRIVATE_OFFICE'
  ) {
    isBPO = true
  }

  return (
    <div
      style={{
        pointerEvents: 'none',
        display: 'flex',
        flexDirection: 'column',
        padding: '16px',
      }}
    >
      {hasBorder && (
        <SpaceSummary
          space={space}
          noSf
          border
          containerStyle={{ paddingBottom: 8 }}
        />
      )}
      {!hasBorder && <SpaceSummary space={space} noSf />}
      {isBPO && <BPO border containerStyle={{ marginBottom: 8 }} />}
      {!isBPO && (
        <>
          <ProductData
            space={space}
            BPO
            border
            containerStyle={{ marginBottom: 8 }}
          />
          <AvailabilityData
            space={space}
            containerStyle={{ marginBottom: 8 }}
          />
        </>
      )}
    </div>
  )
}

export default SpacePreview
